import React from 'react';
import { Carousel } from 'antd';
import styles from './Home.module.scss'
import u3 from '../assets/images/home/u3.jpg'
import u4 from '../assets/images/home/u4.jpg'

import u141 from '../assets/images/home/u141.png'
import u142 from '../assets/images/home/u142.png'
import u143 from '../assets/images/home/u143.png'
import u144 from '../assets/images/home/u144.png'
import u145 from '../assets/images/home/u145.png'
import u146 from '../assets/images/home/u146.png'
import u147 from '../assets/images/home/u147.png'

import u20 from '../assets/images/home/u20.jpg'
import u21 from '../assets/images/home/u21.jpg'
import u22 from '../assets/images/home/u22.jpg'
import u23 from '../assets/images/home/u23.jpg'

import u32 from '../assets/images/home/u32.png'
import u33 from '../assets/images/home/u33.png'
import u34 from '../assets/images/home/u34.png'
import u35 from '../assets/images/home/u35.png'

import u51 from '../assets/images/home/u51.png'
import u52 from '../assets/images/home/u52.png'
import u53 from '../assets/images/home/u53.png'
import u54 from '../assets/images/home/u54.jpg'

import u110 from '../assets/images/home/u110.png'

import u115 from '../assets/images/home/u115.svg'

import { getLangName as t } from '../utils/index'
function Home() {
  const homeList = [
    { img: u3, title: 'LightLink' },
    { img: u4, title: 'LightLink' }
  ]
  return (
    <div className={styles.home}>
      <Carousel autoplay>
        {homeList.map(item => <div className={styles.carousel_item}>
          <img src={item.img} />
        </div>
        )}
      </Carousel>
      <div className={styles.icons}>
        <div className={styles.icons_item}>
          <img src={u143} alt="" />
          <div>{t('HomeEnergyStorage')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u144} alt="" />
          <div>{t('CommercialEnergyStorage')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u145} alt="" />
          <div>{t('CommunicationBaseStationStorage')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u146} alt="" />
          <div>{t('Inverter')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u147} alt="" />
          <div>{t('LeadToLithium')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u141} alt="" />
          <div>{t('LightPower')}</div>
        </div>
        <div className={styles.icons_item}>
          <img src={u142} alt="" />
          <div>{t('Charger')}</div>
        </div>
      </div>
      {/* <div className={styles.products}>
        <div className={styles.products_title}>核心产品</div>
        <div className={styles.products_subtitle}>PRODUCTS</div>
        <div className={styles.products_name}>
          <p>{t('CoreProductsIntro')}</p>
        </div>
      </div>
      <div className={styles.productsBox}>
        <img src={u20} alt="" />
        <img src={u21} alt="" />
        <img src={u22} alt="" />
      </div> */}
      <div className={styles.plans}>
        <div className={styles.plans_item}>
          <img src={u33} />
          <div className={styles.plans_item_title}>{t('OverchargeProtection')}</div>
          <div className={styles.plans_item_line}></div>
          <div className={styles.plans_item_subtitle}>{t('OverchargeProtectionDesc')}</div>
        </div>
        <div className={styles.plans_item}>
          <img src={u34} />
          <div className={styles.plans_item_title}>{t('OverdischargeProtection')}</div>
          <div className={styles.plans_item_line}></div>
          <div className={styles.plans_item_subtitle}>{t('OverdischargeProtectionDesc')}</div>
        </div>
        <div className={styles.plans_item}>
          <img src={u35} />
          <div className={styles.plans_item_title}>{t('TemperatureControl')}</div>
          <div className={styles.plans_item_line}></div>
          <div className={styles.plans_item_subtitle}>{t('TemperatureControlDesc')}</div>
        </div>
        <div className={styles.plans_item}>
          <img src={u32} />
          <div className={styles.plans_item_title}>{t('ShortCircuitProtection')}</div>
          <div className={styles.plans_item_line}></div>
          <div className={styles.plans_item_subtitle}>{t('ShortCircuitProtectionDesc')}</div>
        </div>
      </div>
      <div className={styles.products}>
        <div className={styles.products_title}>解决方案</div>
        <div className={styles.products_subtitle}>Solutions</div>
        <div className={styles.products_name}>
          <p>{t('SolutionsIntro')}</p>
        </div>
      </div>
      <div className={styles.solutions}>
        <div className={styles.solutions_item}>
          <img src={u51} />
          <div className={styles.solutions_item_bg}>
            <div className={styles.solutions_item_title}>{t('EnergyStorageBMS')}</div>
            <div className={styles.solutions_item_line}></div>
            <div className={styles.solutions_item_subtitle}>{t('EnergyStorageBMSSubtitle')}</div>
            <div className={styles.solutions_item_box}>
              {t('EnergyStorageBMSText')}
            </div>
          </div>
        </div>
        <div className={styles.solutions_item}>
          <img src={u52} />
          <div className={styles.solutions_item_bg}>
            <div className={styles.solutions_item_title}>{t('PowerBatteryBMS')}</div>
            <div className={styles.solutions_item_line}></div>
            <div className={styles.solutions_item_subtitle}>{t('PowerBatteryBMSSubtitle')}</div>
            <div className={styles.solutions_item_box}>
              {t('PowerBatteryBMSText')}
            </div>
          </div>
        </div>
        <div className={styles.solutions_item}>
          <img src={u53} />
          <div className={styles.solutions_item_bg}>
            <div className={styles.solutions_item_title}>{t('LeadToLithiumBMS')}</div>
            <div className={styles.solutions_item_line}></div>
            <div className={styles.solutions_item_subtitle}>{t('LeadToLithiumBMSSubtitle')}</div>
            <div className={styles.solutions_item_box}>
              {t('LeadToLithiumBMSText')}
            </div>
          </div>
        </div>
        <div className={styles.solutions_item}>
          <img src={u54} />

          <div className={styles.solutions_item_bg}>
            <div className={styles.solutions_item_title}>{t('SmartDeviceBMS')}</div>
            <div className={styles.solutions_item_line}></div>
            <div className={styles.solutions_item_subtitle}>{t('SmartDeviceBMSSubtitle')}</div>
            <div className={styles.solutions_item_box}>
              {t('SmartDeviceBMSText')}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.products}>
        <div className={styles.products_title}>关于公司</div>
        <div className={styles.products_subtitle} style={{
          marginBottom: '20px',
        }}>About US</div>
      </div>
      <div className={styles.company}>
        <img src={u23} />
        <div className={styles.company_text}>
          深圳市绿电智行科技有限公司成立于2023年12月19日，注册地位于深圳市龙华区福城街道桔塘社区溢佳路6号溢佳工业园。经营范围包括电池销售；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；储能技术服务；电子专用材料研发；电子元器件与机电组件设备销售；半导体器件专用设备销售；蓄电池租赁；通讯设备销售；货物进出口；国内贸易代理；互联网销售；软件开发。
        </div>
      </div>
    </div>

  );
}

export default Home;